import BeelineLogo from './icons/beeline_logo.svg';
import MangoLogo from './icons/mango.svg';
import MaxMessengerLogo from './icons/max-icon.svg';
import YClientsImg from './icons/yclients-logo.svg';
import YooKassaLogo from './icons/yooKassa-logo-small.svg';
import Logo1C from './images/1c-logo.png';
import AvatarImg from './images/avatar.png';
import ByHelpLogo from './images/byhelp-logo.png';
import DevModeImg from './images/dev-mode.png';
import Error403UnathorizedImg from './images/error-403-unauthorized.png';
import LoyaltyIntegrationLogo from './images/loyalty-integration-logo.png';
import PhotoFemale from './images/photo-female.png';
import PhotoMale from './images/photo-male.png';

export {
  AvatarImg,
  Error403UnathorizedImg,
  PhotoFemale,
  PhotoMale,
  YClientsImg,
  ByHelpLogo,
  BeelineLogo,
  DevModeImg,
  MangoLogo,
  YooKassaLogo,
  Logo1C,
  MaxMessengerLogo,
  LoyaltyIntegrationLogo,
};
